import { createContext, useContext } from "react";
import { useForm } from "./form-context.js";
const PanoramaContext = createContext(
  void 0
);
function usePanorama() {
  const context = useContext(PanoramaContext);
  if (context === void 0) {
    throw new Error("usePanorama must be used within a PanoramaProvider");
  }
  const panorama = context.panorama;
  const { namespace } = useForm();
  return {
    transaction: (name) => ({
      start: () => panorama?.transaction(name).start({ namespace }),
      finish: () => panorama?.transaction(name).finish({ namespace })
    })
  };
}
export {
  PanoramaContext,
  usePanorama
};
//# sourceMappingURL=panorama-context.js.map
